import { useLayoutEffect, useRef } from 'react';

import { createInsightsMiddleware } from 'instantsearch.js/cjs/middlewares';
import md5 from 'md5';
import { useInstantSearch } from 'react-instantsearch';
import searchInsights from 'search-insights';

import { ALGOLIA_USER_TOKEN_NAME } from '~/const';
import { useUserInfoContext } from '~/context/UserInfoProvider';
import { checkConsent } from '~/utils/checkConsent';
import { generateRandomString } from '~/utils/stringUtils';

const useInsightsMiddleware = ({
  canCheckToken,
  allowedInsightMethods,
  queryID,
}: {
  canCheckToken?: boolean;
  allowedInsightMethods: string[];
  queryID?: string;
}) => {
  const { addMiddlewares, status } = useInstantSearch();
  const allowedInsightMethodsRef = useRef(allowedInsightMethods);
  const { userInfo } = useUserInfoContext();
  const userId = userInfo?.id;

  useLayoutEffect(() => {
    const middleware = createInsightsMiddleware({
      insightsClient: searchInsights,
      onEvent: (event, searchInsights) => {
        const { insightsMethod, payload, eventType } = event;

        if (
          searchInsights &&
          insightsMethod &&
          eventType === 'click' &&
          allowedInsightMethodsRef.current.includes(insightsMethod)
        ) {
          searchInsights(insightsMethod, { ...payload, queryID });
        }
      },
    });

    if (canCheckToken) {
      if (!userId) {
        if (checkConsent(ALGOLIA_USER_TOKEN_NAME)) {
          const token = localStorage.getItem(ALGOLIA_USER_TOKEN_NAME) || generateRandomString(20);

          localStorage.setItem(ALGOLIA_USER_TOKEN_NAME, token);
          searchInsights('setUserToken', token);
        }
      } else {
        searchInsights('setUserToken', md5(userId));
      }

      addMiddlewares(middleware);
    }

    return addMiddlewares(middleware);
  }, [addMiddlewares, userId, canCheckToken, allowedInsightMethodsRef, queryID]);

  return status;
};

export default useInsightsMiddleware;
